import { useCallback } from "react";

import { UpdateEventFeedbackInput } from "../../../../common/types/events/api";
import { EventViewModel } from "../../models/eventViewModel";
import EventFeedbackDetails from "./EventFeedbackDetails";
import { FeedbackType } from "../../../../API";

interface EventFeedbackDetailsProps {
  event: EventViewModel;
  onUpdateEventFeedback: (input: UpdateEventFeedbackInput) => void;
  loading?: boolean;
}

const FeedbackDetailsTableCellContainer = ({
  event,
  onUpdateEventFeedback,
  loading = false,
}: EventFeedbackDetailsProps) => {
  if (!event.feedback || event.feedback === FeedbackType.NEGATIVE) {
    return null;
  }

  const memoizedUpdateEventFeedbackDetails = useCallback(
    async (mitigatedRisk: string[] | null) => {
      const input: UpdateEventFeedbackInput = {
        pk: event.customerId,
        sk: event.id,
        feedback: event.feedback?.toString() ?? null,
        mitigatedRisk:
          mitigatedRisk && mitigatedRisk.length
            ? mitigatedRisk.join(";")
            : null,
      };

      await onUpdateEventFeedback(input);
    },
    [event.mitigatedRisk]
  );

  const feedbacks = event.mitigatedRisk;

  return (
    <EventFeedbackDetails
      feedbacks={feedbacks}
      loading={loading}
      onAdd={memoizedUpdateEventFeedbackDetails}
      onEdit={memoizedUpdateEventFeedbackDetails}
    />
  );
};

export default FeedbackDetailsTableCellContainer;
